import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { NeedsSignedBOLDto, NeedsSignedBOLQueryParams } from 'dtos/toDoLists/outboundTrips'
import { URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/outbound-trips/needs-signed-bol`

export const getNeedsSignedBOLToDoList = (queryParams: NeedsSignedBOLQueryParams) =>
  apiClient.get<ApiResponse<NeedsSignedBOLDto[]>>(baseUrl() + URIQuery(queryParams)).then(res => res.data)
